import "./css/policy.css";

const Conditions = () => {
    const name = process.env.REACT_APP_APP_NAME || "ExamWorld";

    return (
        <div className="policyMainContainer">

            {/* Header */}
            <header className="policyHeaderContainer">
                <h2 className="policyTitle">Terms & Conditions</h2>
                <p className="policyDate">
                    Effective Date: <strong>01 January 2026</strong>
                </p>
            </header>

            {/* Introduction */}
            <section className="policySection">
                <p>
                    Welcome to <strong>{name}</strong>. By accessing, registering, or using our website, mobile application,
                    mock tests, notes, and educational materials, you agree to be legally bound by these Terms and Conditions.
                    If you do not agree, you must discontinue use of the platform immediately.
                </p>
            </section>

            <section className="policySection">
                <h2>1. Strictly Non-Commercial Use</h2>
                <p>
                    {name} is a platform intended solely for the personal, non-commercial use of individual students.
                </p>
                <ul className="policyList">
                    <li>
                        <strong>Institutional Prohibition:</strong> Any use of our data, test series, or notes by coaching institutes,
                        schools, or commercial entities is a serious offense.
                    </li>
                    <li>
                        <strong>Consequences:</strong> Unauthorized institutional use will result in immediate account termination,
                        a permanent ban, and potential legal action under the Intellectual Property Rights (IPR) and Copyright Act.
                    </li>
                </ul>
            </section>

            <section className="policySection">
                <h2>2. Prohibition on Third-Party Examination Use</h2>
                <p>
                    The content provided by {name} (including practice sets and mock tests) is designed for student preparation only.
                </p>
                <ul className="policyList">
                    <li>
                        <strong>2.1. Prohibition:</strong> The use of our proprietary questions or data by any government agency,
                        recruitment board, or private organization for the conduct of official examinations is
                        <strong> strictly prohibited</strong>.
                    </li>
                    <li>
                        <strong>2.2. Liability Disclaimer:</strong> {name} shall not be held responsible or liable for any legal issues,
                        disputes, or challenges that arise if our data is used by a third party or government body in any official
                        capacity without our written consent.
                    </li>
                </ul>
            </section>

            {/* Scope & Eligibility */}
            <section className="policySection">
                <h2>3. Scope of Service & Eligibility</h2>
                <h3>3.1 Student-Only Platform</h3>
                <p>
                    {name} is designed exclusively for individual students for personal exam preparation. Access or
                    use by commercial entities is strictly prohibited.
                </p>
                <h3>3.2 Age Requirements & Guardianship</h3>
                <ul className="policyList">
                    <li><strong>Age Limit:</strong> To create an account on {name}, you must be at least 18 years of age.</li>
                    <li>
                        <strong>Minors:</strong> If you are under 18, you may only use this platform under the direct supervision and
                        with the verifiable explicit permission of a parent or legal guardian, as per the DPDP Act 2023.
                    </li>
                </ul>
            </section>

            {/* User Conduct (New Addition) */}
            <section className="policySection">
                <h2>4. User Conduct and Ethics</h2>
                <p>We maintain a positive and respectful learning environment. As a user, you agree to the following:</p>
                <ul className="policyList">
                    <li>
                        <strong>Community Standards:</strong> The use of abusive language, hate speech, or harassment in doubt forums, support chats, or comments is strictly prohibited.
                    </li>
                    <li>
                        <strong>Spamming:</strong> Submitting repeated, irrelevant queries to our doubt-resolution experts or support team is not allowed.
                    </li>
                    <li>
                        <strong>Penalty:</strong> Violating these standards will lead to a formal warning. Repeated offenses will result in account suspension without a refund.
                    </li>
                </ul>
            </section>

            {/* Services */}
            <section className="policySection">
                <h2>5. Services and Account Security</h2>
                <h3>5.1 Service Flexibility</h3>
                <p>
                    {name} reserves the right to modify, update, suspend, or discontinue any part of our services at any time.
                </p>
                <h3>5.2 Protection Against Unauthorized Use</h3>
                <p>
                    We maintain a zero-tolerance policy regarding the security of our platform. Prohibited activities include:
                </p>
                <ul className="policyList">
                    <li><strong>Credential Sharing:</strong> Sharing your Login ID or password.</li>
                    <li><strong>Content Piracy:</strong> Copying, recording, or redistributing our proprietary study materials.</li>
                    <li><strong>Technical Tampering:</strong> Attempting to bypass login security.</li>
                </ul>
            </section>

            {/* IP Rights */}
            <section className="policySection">
                <h2>6. Intellectual Property Rights & Ownership</h2>
                <p>
                    All content available on this platform is the exclusive intellectual property of {name}. This content is protected by Indian and International copyright, trademark, and other intellectual property laws.
                </p>
                <ul className="policyList">
                    <li>This is a <strong>Right to Use</strong>, not a transfer of ownership.</li>
                    <li>You may not distribute our content as your own work or remove the {name} branding.</li>
                </ul>
            </section>

            {/* Payments & Refunds */}
            <section className="policySection">
                <h2>7. Payments, Fees, and Ethical Refund Policy</h2>
                <h3>7.1 Payment Finality</h3>
                <p>
                    As {name} provides immediate access to digital intellectual property, standard payments are generally <strong>non-refundable</strong>.
                </p>
                <h3>7.2 Empathetic Consideration (Exceptions)</h3>
                <p>
                    While our standard policy is non-refundable, we understand that life is unpredictable. 
                </p>
                <ul className="policyList">
                    <li>
                        <strong>Management Discretion:</strong> In cases of severe medical emergencies or extreme unforeseen circumstances, users may submit a request to our support team. Management reserves the right to review these requests on a humanitarian basis to offer a partial refund, subscription pause, or validity extension.
                    </li>
                    <li>
                        <strong>Technical Failures:</strong> If you are charged twice due to a payment gateway error, the duplicate amount will automatically be refunded within 5-7 working days.
                    </li>
                </ul>
            </section>

            {/* Termination with Warning System */}
            <section className="policySection">
                <h2>8. Account Suspension and Warning System</h2>
                <p>
                    {name} employs advanced tracking systems to monitor login behavior and prevent unauthorized access.
                </p>
                <ul className="policyList">
                    <li>
                        <strong>Warning System for Minor Faults:</strong> For minor infractions (e.g., inaccurate profile details or accidental simultaneous logins), we will issue a warning first before taking severe action.
                    </li>
                    <li>
                        <strong>Instant Ban for Piracy:</strong> Any attempt at content piracy, automated data scraping, or selling our materials will result in an <strong>immediate and permanent ban without warning and without refund</strong>, followed by legal action under the Information Technology Act, 2000.
                    </li>
                </ul>
            </section>

            {/* Force Majeure (New Addition) */}
            <section className="policySection">
                <h2>9. Force Majeure (Unforeseen Circumstances)</h2>
                <p>
                    {name} shall not be held liable for any delay, interruption, or failure in the provision of services due to circumstances beyond our reasonable control. This includes, but is not limited to:
                </p>
                <ul className="policyList">
                    <li>Natural disasters (Acts of God).</li>
                    <li>Internet blackouts, government-mandated network shutdowns, or regional connectivity issues.</li>
                    <li>Third-party server crashes (e.g., AWS, Cloudflare outages) or payment gateway downtimes.</li>
                </ul>
                <p>In such events, we will strive to restore services as quickly as possible and may compensate users with validity extensions at our discretion.</p>
            </section>

            {/* Consumer Protection Compliance */}
            <section className="policySection">
                <h2>10. Consumer Protection Compliance</h2>
                <p>
                    {name} strictly adheres to the <strong>Consumer Protection (E-Commerce) Rules, 2020</strong>. We are committed to fair trade practices and transparency. We do not engage in any unfair trade practices, false advertising, or hidden charges. All mock test features and pricing are accurately represented before purchase.
                </p>
            </section>

            {/* Law */}
            <section className="policySection">
                <h2>11. Governing Law & Jurisdiction</h2>
                <p>
                    These Terms and Conditions shall be governed by the laws of the Republic of India. In the event of any dispute, it shall be referred to Arbitration. The seat and venue of arbitration shall be Lakhimpur-Kheri, Uttar Pradesh, India.
                </p>
            </section>

        </div>
    );
};

export default Conditions;